export default __webpack_public_path__ + "static/media/494.5504be47.png";